import React from 'react';
import { Typography } from 'fronton-react';
import { GAClickButton } from 'utils/analytics/analytics-events';

import { inline, margin, linkStyles } from './styles';

export const CardRemark = () => {
	const handleClick = () => {
		GAClickButton({
			elementBlock: 'servicePage',
			elementName: 'sale-rules-button',
			elementText: 'Надежный и удобный сервис Лемана ПРО',
		});
	};
	return (
		<Typography
			className={margin}
			variant="caption"
			color="text-secondary"
			data-qa="advantages-card-remark"
			overrideStyles={false}
		>
			* Условия гарантии зависят от&nbsp;услуги.{' '}
			<Typography className={inline} variant="caption" color="text-secondary">
				Подробнее читайте в{' '}
				<a href="/pravila/uslugi/" target="_blank" rel="noopener noreferrer">
					<Typography className={linkStyles} variant="caption" onClick={handleClick}>
						Правилах продажи услуг
					</Typography>
				</a>
				.
			</Typography>
		</Typography>
	);
};
